import { TaskStatusCell } from '../TaskStatusCell';
import { STATUS_ORDER, STATUS_META } from '../statusMeta';
import { TaskInlinePicker } from './TaskInlinePicker';
import type { TaskStatus } from '@/types/task';

interface TaskStatusSelectProps {
  value: TaskStatus;
  disabled?: boolean;
  onChange: (status: TaskStatus) => void;
}

export const TaskStatusSelect = ({ value, disabled = false, onChange }: TaskStatusSelectProps) => (
  <TaskInlinePicker
    label="Status"
    selected={value}
    disabled={disabled}
    options={STATUS_ORDER.map((status) => ({
      value: status,
      label: STATUS_META[status].label,
      node: <TaskStatusCell status={status} />,
    }))}
    onSelect={(next) => next && onChange(next as TaskStatus)}
  >
    <TaskStatusCell status={value} />
  </TaskInlinePicker>
);
